import UmlPackageShape from '../Types/UmlPackageShape';
import UmlClassShape from '../Types/UmlClassShape';
import UmlCaption from '../Types/UmlCaption';
import UmlMemberText from '../Types/UmlMemberText';
import UmlConnector from '../Types/UmlConnector';

// AST -> domain objecten (UmlPackageShape/UmlClassShape/UmlConnector). Kent
// geen PlantUML-syntax, alleen de tokens die PlantUmlParser teruggeeft. Nog
// geen coördinaten hier — dat is UmlAutoLayout na deze stap.
let idCounter = 0;
function nextId(prefix) {
  idCounter += 1;
  return `${prefix}_${idCounter}`;
}

function connectorKindFromArrow(arrow) {
  if (arrow.indexOf('|>') !== -1) {
    return 'inheritance';
  }
  if (arrow.indexOf('.') !== -1) {
    return 'dependency';
  }
  return 'association';
}

function mapMember(memberToken) {
  return new UmlMemberText(nextId('member'), memberToken.text, memberToken.visibility, 'method');
}

// Interfaces map to the same UmlClassShape as classes (no separate shape type
// exists) — 'interface' as the caption.stereotype is the convention the rest
// of the codebase already checks against (see resolveInterfaceReduction.js).
// An explicit PlantUML stereotype (e.g. <<dumb contract>>) is kept as-is
// instead of overwritten, which means such an interface won't be picked up by
// the "Hide Interfaces" reduction (that checks for stereotype === 'interface'
// exactly) — acceptable trade-off, the shape/members/connectors still work.
function mapEntityShape(entityToken) {
  const stereotype = entityToken.stereotype || (entityToken.kind === 'interface' ? 'interface' : null);
  const caption = new UmlCaption(nextId('caption'), 0, 0, entityToken.name, stereotype);
  const classShape = new UmlClassShape(nextId('class'), 0, 0, 200, 100, caption);
  entityToken.members.forEach(function addMember(memberToken) {
    classShape.addMember(mapMember(memberToken));
  });
  return classShape;
}

class PlantUmlMapper {
  toShapesAndConnectors(tokens) {
    const shapes = [];
    const connectors = [];
    const classesByName = {};

    tokens.forEach(function mapToken(token) {
      if (token.kind === 'package') {
        const packageShape = new UmlPackageShape(nextId('package'), 0, 0, 300, 200, token.name);
        token.classes.forEach(function addEntityToPackage(entityToken) {
          const entityShape = mapEntityShape(entityToken);
          classesByName[entityToken.name] = entityShape.id;
          packageShape.addChild(entityShape);
        });
        shapes.push(packageShape);
        return;
      }
      if (token.kind === 'class' || token.kind === 'interface') {
        const entityShape = mapEntityShape(token);
        classesByName[token.name] = entityShape.id;
        shapes.push(entityShape);
        return;
      }
      if (token.kind === 'connector') {
        const connector = new UmlConnector(
          nextId('connector'),
          classesByName[token.from] || token.from,
          classesByName[token.to] || token.to,
          connectorKindFromArrow(token.arrow),
        );
        if (token.label) {
          connector.setLabel(new UmlCaption(nextId('caption'), 0, 0, token.label));
        }
        connectors.push(connector);
      }
    });

    return { shapes, connectors };
  }
}

export default PlantUmlMapper;
